<template>
    <v-dialog v-model="dialogVisible" :persistent="!readOnly" :fullscreen="true" transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>Informativa sulla Privacy e Trattamento Dati</v-toolbar-title>
                <v-spacer v-if="readOnly" />
                <v-btn v-if="readOnly" icon dark @click="chiudi">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text class="pt-6 text-body-1" style="color: rgba(0, 0, 0, 0.87); line-height: 1.6;">

                <h2 class="text-h5 font-weight-bold mb-2">Informativa sul trattamento dei dati personali </h2>
                <h3 class="text-h6 mb-6">Utilizzo dell'applicazione aziendale per rilevazione presenze e gestione
                    richieste di assenza</h3>

                <p class="mb-4">Ai sensi dell'Regolamento (UE) 2016/679 e della normativa nazionale vigente in materia
                    di protezione dei dati personali, si informa il personale dipendente che l'Azienda utilizza
                    un'applicazione informatica accessibile tramite smartphone e altri dispositivi autorizzati per la
                    gestione delle presenze e delle richieste di permesso/assenza.
                </p>

                <h4 class="text-subtitle-1 font-weight-bold mt-4 mb-2">1. Titolare del trattamento </h4>
                <p class="mb-4">
                    Il Titolare del trattamento è:<br>
                    BATTISTI FRANCESCO SNC Sede: Via San Martino, 78 - 12032 Barge (CN)
                </p>

                <h4 class="text-subtitle-1 font-weight-bold mt-4 mb-2">2. Finalità del trattamento </h4>
                <p class="mb-2">L'applicazione è utilizzata per:</p>
                <ul class="mb-4">
                    <li>rilevare e registrare le timbrature di ingresso e uscita;
                    </li>
                    <li>gestire l'orario di lavoro;</li>
                    <li>consentire l'inserimento e la gestione delle richieste di permessi, ferie, assenze e altre
                        giustificazioni;</li>
                    <li>adempiere agli obblighi amministrativi, contrattuali e normativi relativi al rapporto di lavoro;
                    </li>
                    <li>garantire la corretta organizzazione delle attività aziendali.</li>
                </ul>

                <h4 class="text-subtitle-1 font-weight-bold mt-4 mb-2">3. Tipologie di dati trattati</h4>
                <p class="mb-2">Attraverso l'applicazione possono essere trattati:</p>
                <ul class="mb-4">
                    <li>dati identificativi del dipendente (nome, cognome, ecc.);
                    </li>
                    <li>dati relativi alle presenze e agli orari di lavoro;</li>
                    <li>dati relativi alle richieste di ferie, permessi e assenze;</li>
                    <li>causali inserite dal dipendente a giustificazione delle richieste di assenza o permesso;</li>
                    <li>eventuali dati tecnici necessari al funzionamento del sistema (data e ora di accesso,
                        identificativo del dispositivo, log applicativi)</li>
                </ul>

                <h4 class="text-subtitle-1 font-weight-bold mt-4 mb-2">4. Base giuridica del trattamento</h4>
                <p class="mb-2">Il trattamento è effettuato in quanto necessario:
                </p>
                <ul class="mb-4">
                    <li>all'esecuzione del contratto di lavoro;</li>
                    <li>all'adempimento di obblighi di legge cui è soggetto il Titolare;</li>
                    <li>al perseguimento del legittimo interesse del Titolare alla gestione e organizzazione
                        dell'attività aziendale, nel rispetto dei diritti e delle libertà dei lavoratori.</li>
                </ul>

                <h4 class="text-subtitle-1 font-weight-bold mt-4 mb-2">5. Accesso alle informazioni</h4>
                <p class="mb-2">Le informazioni contenute nell'applicazione sono accessibili esclusivamente al personale
                    autorizzato. </p>
                <p class="mb-2">In particolare:</p>
                <ul class="mb-4">
                    <li>i dipendenti possono visualizzare esclusivamente le informazioni che li riguardano;</li>
                    <li>le causali dettagliate inserite a supporto delle richieste di permesso o assenza sono
                        accessibili esclusivamente agli amministratori del sistema e al personale aziendale
                        espressamente autorizzato alla gestione del personale;
                    </li>
                    <li>gli altri dipendenti non possono visualizzare tali causali.</li>
                </ul>

                <h4 class="text-subtitle-1 font-weight-bold mt-4 mb-2">6. Modalità del trattamento</h4>
                <p class="mb-4">I dati sono trattati mediante strumenti informatici e telematici, con misure tecniche e
                    organizzative adeguate a garantirne la sicurezza, la riservatezza e l'integrità.</p>

                <h4 class="text-subtitle-1 font-weight-bold mt-4 mb-2">7. Conservazione dei dati</h4>
                <p class="mb-4">I dati sono conservati per il tempo necessario al conseguimento delle finalità sopra
                    indicate e comunque nel rispetto degli obblighi di legge applicabili in materia di lavoro,
                    amministrazione del personale e conservazione documentale.
                </p>

                <h4 class="text-subtitle-1 font-weight-bold mt-4 mb-2">8. Comunicazione dei dati</h4>
                <p class="mb-2">I dati potranno essere comunicati:</p>
                <ul class="mb-2">
                    <li>a soggetti che forniscono servizi informatici e di manutenzione dell'applicazione, nominati
                        responsabili del trattamento ove previsto;</li>
                    <li>a consulenti del lavoro, professionisti e soggetti che supportano l'Azienda nella gestione del
                        personale;</li>
                    <li>ad autorità pubbliche e organismi competenti nei casi previsti dalla legge.</li>
                </ul>
                <p class="mb-4">I dati non saranno diffusi.</p>

                <h4 class="text-subtitle-1 font-weight-bold mt-4 mb-2">9. Diritti dell'interessato </h4>
                <p class="mb-2">L'interessato può esercitare i diritti previsti dagli articoli 15 e seguenti del GDPR,
                    tra cui:</p>
                <ul class="mb-2">
                    <li>accesso ai dati personali;</li>
                    <li>rettifica dei dati inesatti;</li>
                    <li>cancellazione nei casi previsti dalla legge;</li>
                    <li>limitazione del trattamento;</li>
                    <li>opposizione al trattamento nei casi consentiti;</li>
                    <li>reclamo all'Garante per la protezione dei dati personali.</li>
                </ul>
                <p class="mb-4">Le richieste possono essere inviate al Titolare del trattamento ai recapiti sopra
                    indicati.</p>

                <h4 class="text-subtitle-1 font-weight-bold mt-4 mb-2">10. Informazioni ulteriori </h4>
                <p class="mb-4">L'utilizzo dell'applicazione è finalizzato esclusivamente alla gestione del rapporto di
                    lavoro e non comporta forme di controllo a distanza dei lavoratori ulteriori rispetto a quelle
                    consentite dalla normativa vigente, inclusi l'Statuto dei Lavoratori e la disciplina in materia di
                    protezione dei dati personali.</p>

                <v-checkbox v-if="!readOnly" v-model="haSpuntato"
                    label="Dichiaro di aver letto e compreso l'informativa sulla privacy" color="primary" hide-details
                    class="mt-6 font-weight-bold" />
            </v-card-text>

            <v-divider />
            <v-card-actions class="pa-4">
                <v-spacer />
                <v-btn v-if="readOnly" color="primary" large @click="chiudi">
                    <v-icon left>close</v-icon>
                    Chiudi
                </v-btn>
                <v-btn v-else color="success" large :disabled="!haSpuntato" :loading="isLoading"
                    @click="confermaPrivacy">
                    <v-icon left>check</v-icon>
                    Accetta e Prosegui
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
// Importa la tua chiamata API (adegua il percorso)
import { salva_spunta_privacy } from '@/api/api.user.js';

export default {
    name: 'PrivacyDialog',

    data() {
        return {
            haSpuntato: false,
            isLoading: false
        }
    },

    props: {
        readOnly: {
            type: Boolean,
            default: false
        },
        // Usata solo in modalità readOnly per controllare apertura/chiusura dall'esterno
        value: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        // Presuppongo che tu abbia i dati utente nello store. 
        // Modifica i getters in base a come hai strutturato il tuo Vuex.
        utenteLoggato() {
            return !!this.$store.getters["user/getUserId"];
        },

        spuntaPrivacyDaSessione() {
            // Recupera il boolean dalla sessione
            return this.$store.getters["user/getSpuntaPrivacy"];
        },

        dialogVisible: {
            get() {
                if (this.readOnly) {
                    return this.value;
                }
                return this.utenteLoggato && this.spuntaPrivacyDaSessione === false;
            },
            set(val) {
                if (this.readOnly) {
                    this.$emit('input', val);
                }
                // In modalità obbligatoria non si può chiudere dall'esterno
            }
        }
    },

    methods: {
        async confermaPrivacy() {
            this.isLoading = true;

            try {
                // Aggiorna lo stato di Vuex per far scomparire la dialog istantaneamente
                this.$store.commit("user/SET_SPUNTA_PRIVACY", true);

                await salva_spunta_privacy();

                // Opzionale: resetta la checkbox per il futuro
                this.haSpuntato = false;

            } catch (error) {
                console.error("Errore nel salvataggio della privacy:", error);
                // Qui potresti mostrare uno snackbar di errore
                alert("Si è verificato un errore durante il salvataggio. Riprova.");
            } finally {
                this.isLoading = false;
            }
        },

        chiudi() {
            this.$emit('input', false);
        },
    }
}
</script>